import { Result } from '@empathy/search-types';
import { EmpathizeState, EmpathyXConfig } from '../../../models';
import { GETTERS_KEYS } from '../../store.const';
import { RootStoreState } from '../../store.interfaces';
import { EMPATHIZE_GETTERS_KEYS } from '../empathize.const';
import { EmpathizeGetter } from '../empathize.interfaces';

export class ResultsSuggestionsGetter implements EmpathizeGetter {
  getters = {
    [EMPATHIZE_GETTERS_KEYS.resultsSuggestions]: (localState: EmpathizeState, getters: any, rootState: RootStoreState,
      rootGetters: any): Result[] => {
      const { resultsSuggestions: config }: EmpathyXConfig = rootGetters[GETTERS_KEYS.config.config];
      return localState.resultsSuggestions.slice(0, config.size);
    },
    [EMPATHIZE_GETTERS_KEYS.identifierSuggestions]: (localState: EmpathizeState, getters: any, rootState: RootStoreState,
      rootGetters: any): Result[] => {
      const { identifierSuggestions: config }: EmpathyXConfig = rootGetters[GETTERS_KEYS.config.config];
      return localState.identifierSuggestions.slice(0, config.size);
    }
  };
}
